import React from 'react';
import Header from '../components/Header';
import CaseStudiesHero from '../components/CaseStudyOne/CaseStudiesHero';
import CaseStudiesBeginning from '../components/CaseStudyOne/CaseStudiesBeginning';
import CaseStudiesTesting from '../components/CaseStudyOne/CaseStudiesTesting';
import CaseStudiesResults from '../components/CaseStudyOne/CaseStudiesResults';
import CaseStudiesCallout from '../components/CaseStudyOne/CaseStudiesCallout';
import '../styles/custom.css';

const CaseStudiesPage = () => {
  return (
    
    <div className="page-wrapper">
      <Header />
      <CaseStudiesHero />
      <CaseStudiesBeginning />
      <CaseStudiesTesting />
      <CaseStudiesResults />
      <CaseStudiesCallout />
    </div>
  );
}

export default CaseStudiesPage;